const messages = {
  title: "Sobre a Bridgestone",
  description:
    "O SEU PLUS COM A BRIDGESTONE - este é o nosso lema para o programa BRIDGESTONE PLUS para os nossos parceiros comerciais. Descubra as inúmeras vantagens exclusivas.",
};

export default {
  messages,
};
